"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createCanvas(width, height) {
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas.getContext("2d");
}
exports.default = createCanvas;
